import "./styles/corporate_register.scss";
import { AppContext } from '../../Context.tsx';
import { Typography, useScrollTrigger } from "@mui/material";
import React, { useContext, useEffect, useRef } from "react";
import "./register.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import SelectInput from "../../components/TextInput/SelectInput";
import Button from "@mui/material/Button";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import { useForm } from "react-hook-form";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import LandLinePhoneFormatter from "../../components/PhoneFormatter/LandLinePhoneFormatter";
import { MuiTelInput } from "mui-tel-input";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { notification } from "antd";
import ApplicationFormController from "../Admin/Controller/application_form_controller.ts";
import styled from "@mui/system/styled";
import DatabaseInterfaceController from '../../i-controllers/DatabaseInterfaceController.tsx';
// import HCaptcha from '@hcaptcha/react-hcaptcha'; ---deprecated of unused
import ICaptcha from '../../i-components/ICaptcha.tsx';

/** edited by delon 2025-05-30 */
import { useState, Fragment } from "react";
import axios from 'axios';
import { IonDate, IonDateString, IonDateFormat } from '../../i-components/IonDate.tsx';

const Item = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  border: "1px solid",
  borderColor: "#ced7e0",
  padding: theme.spacing(1),
  borderRadius: "4px",
  textAlign: "center",
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
    borderColor: "#444d58",
  }),
}));

const Register = () => {
  /** edited by delon on 2025-05-30 */
  //contexts
  const appContext = useContext(AppContext);
  //states
  const [popupMessage, SetPopupMessage] = useState("");
  const [popupAction, SetPopupAction] = useState(() => {});
  // const [hCaptchaToken, SetHCaptchaToken] = useState('');
  const [captchaVerification, SetCaptchaVerification] = useState(null);
  //refs
  // const hCaptchaTokenRef = useRef(''); ---deprecated of unused
  //controllers
  const database = new DatabaseInterfaceController(appContext);

  //parameters declaration
  const key = "12345";
  /* key has no length limit, the longer the length more exhaustive encryption/decryption to process. Key shall not have 0, any 0's will be autoremoved */

  const mode = "YMDHI"; //optional parameter, default will be 'YMDHI'

  //initialize encyptor
  const Encryptor = new InfinityEncryptor(key, mode);
  const Encryptor2 = new InfinityEncryptor('22499', 'MYDIH'); //used by mobile_backend/scripts/mailControl

  //watchers
  //watch for hCaptchaToken updated, verifyHCaptcha
  // useEffect(() => {
  //   if(hCaptchaToken != hCaptchaTokenRef.current) {
  //     database.Queue('verifyHCaptcha', [
  //       ['verifyHCaptcha', 'true'],
  //       ['token', hCaptchaToken]
  //     ])
  //     hCaptchaTokenRef.current = hCaptchaToken;
  //   }
  // }, [hCaptchaToken]); ---deprecated of unused

  //watch for databaseResultAction
  // useEffect(() => {
  //   if(appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction) {
  //     const ExecuteDatabaseResultAction = async() => {
  //       const [res, mode] = await appContext.databaseResultAction();

  //       switch(mode) {
  //           case 'verifyHCaptcha':
  //             if(!JSON.stringify(res).includes('_false')) {
  //               SetHCaptchaVerified(true);
  //             }
  //           break;
  //       }
  //     };

  //     switch(appContext.databaseActionModeQueue[0]) {
  //       case 'verifyHCaptcha':
  //         ExecuteDatabaseResultAction();
  //         break;
  //     }
  //   }
  // }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]); ---deprecated of unused


  const required = () => <span style={{ color: "red", marginLeft: "5px", fontSize: "17px" }}>*</span>;

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setError,
    getValues,
    clearErrors,
    setFocus,
  } = useForm({
    defaultValues: {
      nameOfCompany: "",
      registeredAddressStreet: "",
      registeredAddressState: "",
      registeredAddressCity: "",
      registeredAddressPostcode: "",
      correspondenceAddressStreet: "",
      correspondenceAddressState: "",
      correspondenceAddressCity: "",
      correspondenceAddressPostcode: "",
      companyNumber: "",
      dateOfIncorporation: "",
      correspondenceAddress: "",
      nameOfBuilding: "",
      website: "",
      companyTelephoneNo: "",
      companyEmail: "",
      grossBuiltUpArea: "",
      nettLettableArea: "",
      eInvoiceNumber: "",
      noOfFloor: "",
      noOfCarPark: "",
      appointedRepresentativeSalutation: "",
      appointedRepresentativeName: "",
      appointedRepresentativeNRIC: "",
      appointedRepresentativeDOB: "",
      appointedRepresentativeOfficeTelNo: "",
      appointedRepresentativeHPNo: "",
      appointedRepresentativeEmail: "",
      appointedRepresentativeDesignation: "",
      appointedRepresentativeNatureOfWork: "",
      appointedRepresentativeNoOfYearsWithCompany: "",
      appointedRepresentativeAcademicQualification: "",
      alternateRepresentativeSalutation: "",
      alternateRepresentativeName: "",
      alternateRepresentativeNRIC: "",
      alternateRepresentativeDOB: "",
      alternateRepresentativeOfficeTelNo: "",
      alternateRepresentativeHPNo: "",
      alternateRepresentativeEmail: "",
      alternateRepresentativeDesignation: "",
      alternateRepresentativeNatureOfWork: "",
      alternateRepresentativeNoOfYearsWithCompany: "",
      alternateRepresentativeAcademicQualification: "",
      othersSalutation: "",
      othersName: "",
      othersNRIC: "",
      othersEmail: "",
      othersHPNo: "",
      othersDOB: "",
      othersOfficeTelNo: "",
      othersDesignation: "",
      othersNatureOfWork: "",
      othersNoOfYearsWithCompany: "",
      othersAcademicQualification: "",
      CorporateMembershipCategory: "",
    },
  });

  const userID = localStorage.getItem("userID");

  const onSubmit = async (data) => {
    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }

    const formData = new FormData();

    if (data.appointedRepresentativeEmail && data.alternateRepresentativeEmail && data.appointedRepresentativeEmail === data.alternateRepresentativeEmail) {
      setError("alternateRepresentativeEmail", {
        type: "manual",
        message: "This email is already used in another field!",
      });
      setFocus("alternateRepresentativeEmail");
      return;
    }

    const registeredAddressFields = [data.registeredAddressStreet, data.registeredAddressPostcode, data.registeredAddressCity, data.registeredAddressState];

    const formattedRegisteredAddress = registeredAddressFields.filter(Boolean).join(", ");

    const correspondenceAddressFields = [data.correspondenceAddressStreet, data.correspondenceAddressPostcode, data.correspondenceAddressCity, data.correspondenceAddressState];

    const formattedCorrespondenceAddress = correspondenceAddressFields.filter(Boolean).join(", ");

    formData.append("CorporateMembershipCategory", Encryptor.Encrypt(TrimFormData(data.CorporateMembershipCategory)));
    formData.append("nameOfCompany", Encryptor.Encrypt(TrimFormData(data.nameOfCompany)));

    formData.append("registeredAddress", Encryptor.Encrypt(TrimFormData(formattedRegisteredAddress)));
    formData.append("registeredAddressState", Encryptor.Encrypt(TrimFormData(data.registeredAddressState)));
    formData.append("companyNumber", Encryptor.Encrypt(TrimFormData(data.companyNumber)));
    formData.append("dateOfIncorporation", Encryptor.Encrypt(TrimFormData(data.dateOfIncorporation)));

    formData.append("correspondenceAddress", Encryptor.Encrypt(TrimFormData(formattedCorrespondenceAddress)));
    formData.append("correspondenceAddressState", Encryptor.Encrypt(TrimFormData(data.correspondenceAddressState)));
    formData.append("nameOfBuilding", Encryptor.Encrypt(TrimFormData(data.nameOfBuilding)));
    formData.append("website", Encryptor.Encrypt(TrimFormData(data.website)));
    formData.append("companyTelephoneNo", Encryptor.Encrypt(TrimFormData(data.companyTelephoneNo)));

    formData.append("companyEmail", Encryptor.Encrypt(TrimFormData(data.companyEmail)));
    formData.append("grossBuiltUpArea", Encryptor.Encrypt(TrimFormData(data.grossBuiltUpArea)));
    formData.append("nettLettableArea", Encryptor.Encrypt(TrimFormData(data.nettLettableArea)));

    formData.append("eInvoiceNumber", Encryptor.Encrypt(TrimFormData(data.eInvoiceNumber)));
    formData.append("noOfFloor", Encryptor.Encrypt(TrimFormData(data.noOfFloor)));
    formData.append("noOfCarPark", Encryptor.Encrypt(TrimFormData(data.noOfCarPark)));
    formData.append("appointedRepresentativeSalutation", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeSalutation)));
    formData.append("appointedRepresentativeName", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeName)));
    formData.append("appointedRepresentativeNRIC", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeNRIC)));
    formData.append("appointedRepresentativeDOB", Encryptor.Encrypt(TrimFormData(dayjs(data.appointedRepresentativeDOB).format("YYYY-MM-DD"))));
    formData.append("appointedRepresentativeOfficeTelNo", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeOfficeTelNo)));
    formData.append("appointedRepresentativeHPNo", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeHPNo.replace("+", ""))));
    formData.append("appointedRepresentativeEmail", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeEmail)));

    formData.append("appointedRepresentativeDesignation", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeDesignation)));
    formData.append("appointedRepresentativeNatureOfWork", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeNatureOfWork)));
    formData.append("appointedRepresentativeNoOfYearsWithCompany", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeNoOfYearsWithCompany)));
    formData.append("appointedRepresentativeAcademicQualification", Encryptor.Encrypt(TrimFormData(data.appointedRepresentativeAcademicQualification)));
    formData.append("alternateRepresentativeSalutation", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeSalutation)));

    formData.append("alternateRepresentativeName", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeName)));
    formData.append("alternateRepresentativeNRIC", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeNRIC)));
    formData.append("alternateRepresentativeDOB", Encryptor.Encrypt(TrimFormData(dayjs(data.alternateRepresentativeDOB).format("YYYY-MM-DD"))));
    formData.append("alternateRepresentativeOfficeTelNo", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeOfficeTelNo)));
    formData.append("alternateRepresentativeHPNo", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeHPNo.replace("+", ""))));
    formData.append("alternateRepresentativeEmail", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeEmail)));

    formData.append("alternateRepresentativeDesignation", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeDesignation)));
    formData.append("alternateRepresentativeNatureOfWork", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeNatureOfWork)));
    formData.append("alternateRepresentativeNoOfYearsWithCompany", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeNoOfYearsWithCompany)));
    formData.append("alternateRepresentativeAcademicQualification", Encryptor.Encrypt(TrimFormData(data.alternateRepresentativeAcademicQualification)));
    formData.append("othersSalutation", Encryptor.Encrypt(TrimFormData(data.othersSalutation)));
    formData.append("othersName", Encryptor.Encrypt(TrimFormData(data.othersName)));
    formData.append("othersNRIC", Encryptor.Encrypt(TrimFormData(data.othersNRIC)));
    formData.append("othersEmail", Encryptor.Encrypt(TrimFormData(data.othersEmail)));
    formData.append("othersHPNo", Encryptor.Encrypt(TrimFormData(data.othersHPNo)));
    formData.append("othersDOB", Encryptor.Encrypt(TrimFormData(data.othersOfficeTelNo)));
    formData.append("othersOfficeTelNo", Encryptor.Encrypt(TrimFormData(data.othersOfficeTelNo)));
    formData.append("othersDesignation", Encryptor.Encrypt(TrimFormData(data.othersDesignation)));
    formData.append("othersNatureOfWork", Encryptor.Encrypt(TrimFormData(data.othersNatureOfWork)));
    formData.append("othersNoOfYearsWithCompany", Encryptor.Encrypt(TrimFormData(data.othersNoOfYearsWithCompany)));
    formData.append("othersAcademicQualification", Encryptor.Encrypt(TrimFormData(data.othersAcademicQualification)));

    formData.append("userID", TrimFormData(userID));

    // console.log(data.appointedRepresentativeSalutation);
    // console.log(data.alternateRepresentativeSalutation);
    // console.log(data.othersSalutation);

    try {
      const response = await ApplicationFormController.submitCorporateApplication(formData);
      console.log(response);
      if (response.status === "success") {
        reset();
        window.scrollTo({ top: 0, behavior: "smooth" });
        // openNotificationWithIcon(
        //   "success",
        //   "Application has been submitted!",
        //   "Success"
        // );

        SetPopupMessage("Your registration has been submitted successfully.");
        SetPopupAction(() => () => {
          SetPopupMessage("");
        });

        //membership registration success, send notification to secretariate mail here
        SendNewRegistrationNotificationToSecretariate(data);
      }
    } catch (error) {
      SetPopupMessage("Failed to submit your registration.\nPlease try again or contact PPK's support.");
      SetPopupAction(() => () => {
        SetPopupMessage("");
      });
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, message) => {
    api[type]({
      message: message,
      description: desc,
    });
  };

  //edited by delon on 2025-05-30
  //render functions
  const RenderPopupMessageBox = () => {
    return (
      <Fragment>
        <div className="popup-ui-block" />
        <div className="popup-message-box">
          <span className="popup-message-lbl">{popupMessage}</span>
          <div className="option-panel">
            <button className="option-btn" onClick={() => popupAction()}>
              Done
            </button>
          </div>
        </div>
      </Fragment>
    );
  };

  //added by delon 2025-07-23 to do formdata checking and purging
  const TrimFormData = (data) => {
    //replace "'" character -> "`"
    let res = data.toString();
    res = data.toString().replace(/'/g, "`");
    return res;
  }

  //addeed by delon 2025-12-02
  const SendNewRegistrationNotificationToSecretariate = (data) => {
    const formData = new FormData();
    const dateNow = new Date();
    formData.append('s3cr3t', Encryptor2.Encrypt('ppkm_14082024_mobile'));
    formData.append('sendNewRegistrationNotification', Encryptor2.Encrypt('true'));
    formData.append('type', Encryptor2.Encrypt('CORPORATE'));
    formData.append('name', Encryptor2.Encrypt(data.nameOfCompany));
    formData.append('datetime', Encryptor2.Encrypt(IonDateString(dateNow, IonDateFormat.MALAYSIA_STANDARD)));

    axios.post('https://www.ppkm.org.my/mobile_backend/scripts/mailControl.php', formData, { withCredentials: false }).then((res) => {
      const resData = res.data;

      if(JSON.stringify(resData).includes('_false')) {
        console.log('SendNewRegistrationNotificationToSecretariateErr ' + resData);
      }
    }).catch((err) => {
      console.log('SendNewRegistrationNotificationToSecretariateErr ' + err);
    });
  }

  return (
    <>
      {contextHolder}

      <form onSubmit={handleSubmit(onSubmit, onInvalid, { shouldFocusError: true })}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid size={{ xs: 12, md: 12 }} sx={{ marginBottom: "10px" }}>
            <Typography variant="h6" gutterBottom>
              Category of Membership{required()}
            </Typography>
            <SelectInput
              type="select"
              {...register("CorporateMembershipCategory", {
                required: "This field is required",
              })}
              onErrorCheck={errors.CorporateMembershipCategory ? errors.CorporateMembershipCategory.message : ""}
              control={control}
            />
          </Grid>
          <Typography variant="h5" sx={{ fontWeight: "bold" }} gutterBottom>
            Company Info
          </Typography>

          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Name of Company{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("nameOfCompany", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.nameOfCompany ? errors.nameOfCompany.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Date of Incorporation
              </Typography>
              <BasicDatePicker
                {...register("dateOfIncorporation", {
                  required: false,
                })}
                onErrorCheck={errors.dateOfIncorporation ? errors.dateOfIncorporation.message : ""}
                control={control}
                name="dateOfIncorporation"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Co. Registration No.{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("companyNumber", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.companyNumber ? errors.companyNumber.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Name of Building/Mall being represented{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("nameOfBuilding", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.nameOfBuilding ? errors.nameOfBuilding.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Website Address
              </Typography>
              <TextInput type="text" {...register("website")} onErrorCheck={errors.website ? errors.website.message : ""} control={control} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Telephone No.
              </Typography>

              <LandLinePhoneFormatter name="companyTelephoneNo" onErrorCheck={errors.companyTelephoneNo ? errors.companyTelephoneNo.message : ""} control={control} />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Email
              </Typography>
              <TextInput
                type="email"
                name="companyEmail"
                {...register("companyEmail", {
                  required: false,
                })}
                onErrorCheck={errors.companyEmail ? errors.companyEmail.message : ""}
                onEmailCheck={(error) => {
                  if (error?.type === "invalidFormat") {
                    setError("companyEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicate") {
                    setError("companyEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicateInForm") {
                    setError("companyEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else {
                    clearErrors("companyEmail");
                  }
                }}
                control={control}
                getValues={getValues}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Gross Built Up Area (sq. ft.)
              </Typography>
              <TextInput
                type="text"
                {...register("grossBuiltUpArea", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.grossBuiltUpArea ? errors.grossBuiltUpArea.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Nett Lettable Area (sq. ft.)
              </Typography>
              <TextInput
                type="text"
                {...register("nettLettableArea", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.nettLettableArea ? errors.nettLettableArea.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                No. of Floor
              </Typography>
              <TextInput
                type="text"
                {...register("noOfFloor", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.noOfFloor ? errors.noOfFloor.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                No. of Car Park
              </Typography>
              <TextInput
                type="text"
                {...register("noOfCarPark", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.noOfCarPark ? errors.noOfCarPark.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Co. TIN No.{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("eInvoiceNumber", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.eInvoiceNumber ? errors.eInvoiceNumber.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }} gutterBottom>
                Company Registered Address
              </Typography>
            </Grid>

            <Grid size={{ xs: 6, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Street Address{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("registeredAddressStreet", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.registeredAddressStreet ? errors.registeredAddressStreet.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                Postcode{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("registeredAddressPostcode", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.registeredAddressPostcode ? errors.registeredAddressPostcode.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                City{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("registeredAddressCity", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.registeredAddressCity ? errors.registeredAddressCity.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                State{required()}
              </Typography>
              <SelectInput
                type="text"
                {...register("registeredAddressState", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.registeredAddressState ? errors.registeredAddressState.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }} gutterBottom>
                Company Correspondence Address
              </Typography>
            </Grid>

            <Grid size={{ xs: 6, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Street Address{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("correspondenceAddressStreet", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.correspondenceAddressStreet ? errors.correspondenceAddressStreet.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                Postcode{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("correspondenceAddressPostcode", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.correspondenceAddressPostcode ? errors.correspondenceAddressPostcode.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                City{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("correspondenceAddressCity", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.correspondenceAddressCity ? errors.correspondenceAddressCity.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                State{required()}
              </Typography>
              <SelectInput
                type="text"
                {...register("correspondenceAddressState", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.correspondenceAddressState ? errors.correspondenceAddressState.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", marginTop: "50px" }} gutterBottom>
                Appointed Representative Info
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <Typography variant="h6" gutterBottom>
                Salutation
              </Typography>
              <TextInput
                type="text"
                {...register("appointedRepresentativeSalutation", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeSalutation ? errors.appointedRepresentativeSalutation.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 9 }}>
              <Typography variant="h6" gutterBottom>
                Name
              </Typography>
              <TextInput
                type="text"
                {...register("appointedRepresentativeName", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeName ? errors.appointedRepresentativeName.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                NRIC Number
              </Typography>
              <TextInput
                type="text"
                {...register("appointedRepresentativeNRIC", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeNRIC ? errors.appointedRepresentativeNRIC.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Date of Birth
              </Typography>
              <BasicDatePicker
                {...register("appointedRepresentativeDOB", {
                  required: false,
                })}
                onErrorCheck={errors.appointedRepresentativeDOB ? errors.appointedRepresentativeDOB.message : ""}
                control={control}
                name="appointedRepresentativeDOB"
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Office Tel. No.
              </Typography>
              <LandLinePhoneFormatter name="appointedRepresentativeOfficeTelNo" onErrorCheck={errors.appointedRepresentativeOfficeTelNo ? errors.appointedRepresentativeOfficeTelNo.message : ""} control={control} />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                H/phone No.
              </Typography>
              <Controller
                name="appointedRepresentativeHPNo"
                control={control}
                // rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <MuiTelInput
                    {...field}
                    value={field.value}
                    onChange={field.onChange}
                    defaultCountry="MY"
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        fontSize: "16px",
                        borderRadius: "25px",
                        color: "black",
                        backgroundColor: "white",
                        "& fieldset": {
                          borderColor: "#ccc",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                        // "&.Mui-focused fieldset": {
                        //   borderColor: "transparent",
                        //   outline: "none",
                        // },
                      },
                    }}
                    error={Boolean(errors.appointedRepresentativeHPNo)}
                    helperText={errors.appointedRepresentativeHPNo ? errors.appointedRepresentativeHPNo.message : ""}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Email
              </Typography>
              <TextInput
                type="email"
                {...register("appointedRepresentativeEmail", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeEmail ? errors.appointedRepresentativeEmail.message : ""}
                onEmailCheck={(error) => {
                  if (error?.type === "invalidFormat") {
                    setError("appointedRepresentativeEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicate") {
                    setError("appointedRepresentativeEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicateInForm") {
                    setError("appointedRepresentativeEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else {
                    clearErrors("appointedRepresentativeEmail");
                  }
                }}
                control={control}
                getValues={getValues} // <-- Pass getValues here
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>
              <TextInput
                type="text"
                {...register("appointedRepresentativeDesignation", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeDesignation ? errors.appointedRepresentativeDesignation.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Nature of Work
              </Typography>
              <TextInput
                type="text"
                {...register("appointedRepresentativeNatureOfWork", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeNatureOfWork ? errors.appointedRepresentativeNatureOfWork.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Number of Years With Company
              </Typography>
              <TextInput
                type="number"
                {...register("appointedRepresentativeNoOfYearsWithCompany", {
                  required: false,
                })}
                onErrorCheck={errors.appointedRepresentativeNoOfYearsWithCompany ? errors.appointedRepresentativeNoOfYearsWithCompany.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Academic Qualifications
              </Typography>
              <SelectInput
                type="select"
                {...register("appointedRepresentativeAcademicQualification", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.appointedRepresentativeAcademicQualification ? errors.appointedRepresentativeAcademicQualification.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", marginTop: "50px" }} gutterBottom>
                Alternate Representative Info
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <Typography variant="h6" gutterBottom>
                Salutation
              </Typography>
              <TextInput
                type="text"
                {...register("alternateRepresentativeSalutation", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeSalutation ? errors.alternateRepresentativeSalutation.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 9 }}>
              <Typography variant="h6" gutterBottom>
                Name
              </Typography>
              <TextInput
                type="text"
                {...register("alternateRepresentativeName", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeName ? errors.alternateRepresentativeName.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                NRIC Number
              </Typography>
              <TextInput
                type="text"
                {...register("alternateRepresentativeNRIC", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeNRIC ? errors.alternateRepresentativeNRIC.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Date of Birth
              </Typography>
              <BasicDatePicker
                {...register("alternateRepresentativeDOB", {
                  required: false,
                })}
                onErrorCheck={errors.alternateRepresentativeDOB ? errors.alternateRepresentativeDOB.message : ""}
                control={control}
                name="alternateRepresentativeDOB"
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Office Tel. No.
              </Typography>

              <LandLinePhoneFormatter name="alternateRepresentativeOfficeTelNo" onErrorCheck={errors.alternateRepresentativeOfficeTelNo ? errors.alternateRepresentativeOfficeTelNo.message : ""} control={control} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                H/phone No.
              </Typography>
              <Controller
                name="alternateRepresentativeHPNo"
                control={control}
                // rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <MuiTelInput
                    {...field}
                    value={field.value}
                    onChange={field.onChange}
                    defaultCountry="MY"
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        fontSize: "16px",
                        borderRadius: "25px",
                        color: "black",
                        backgroundColor: "white",
                        "& fieldset": {
                          borderColor: "#ccc",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                        // "&.Mui-focused fieldset": {
                        //   borderColor: "transparent",
                        //   outline: "none",
                        // },
                      },
                    }}
                    error={Boolean(errors.alternateRepresentativeHPNo)}
                    helperText={errors.alternateRepresentativeHPNo ? errors.alternateRepresentativeHPNo.message : ""}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Email
              </Typography>
              <TextInput
                type="email"
                {...register("alternateRepresentativeEmail", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeEmail ? errors.alternateRepresentativeEmail.message : ""}
                onEmailCheck={(error) => {
                  console.log(error);
                  if (error?.type === "invalidFormat") {
                    setError("alternateRepresentativeEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "dulplicate") {
                    setError("alternateRepresentativeEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicateInForm") {
                    setError("alternateRepresentativeEmail", {
                      type: "manual",
                      message: error.message,
                    });
                  } else {
                    clearErrors("alternateRepresentativeEmail");
                  }
                }}
                control={control}
                getValues={getValues} // <-- Pass getValues here
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>
              <TextInput
                type="text"
                {...register("alternateRepresentativeDesignation", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeDesignation ? errors.alternateRepresentativeDesignation.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Nature of Work
              </Typography>
              <TextInput
                type="text"
                {...register("alternateRepresentativeNatureOfWork", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeNatureOfWork ? errors.alternateRepresentativeNatureOfWork.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Number of Years With Company
              </Typography>
              <TextInput
                type="number"
                {...register("alternateRepresentativeNoOfYearsWithCompany", {
                  required: false,
                })}
                onErrorCheck={errors.alternateRepresentativeNoOfYearsWithCompany ? errors.alternateRepresentativeNoOfYearsWithCompany.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Academic Qualification
              </Typography>
              <SelectInput
                type="select"
                {...register("alternateRepresentativeAcademicQualification", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.alternateRepresentativeAcademicQualification ? errors.alternateRepresentativeAcademicQualification.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", marginTop: "50px" }} gutterBottom>
                Other Member Info
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <Typography variant="h6" gutterBottom>
                Salutation
              </Typography>
              <TextInput
                type="text"
                {...register("othersSalutation", {
                  required: false,
                })}
                onErrorCheck={errors.othersSalutation ? errors.othersSalutation.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 9 }}>
              <Typography variant="h6" gutterBottom>
                Name
              </Typography>
              <TextInput
                type="text"
                {...register("othersName", {
                  required: false,
                })}
                onErrorCheck={errors.othersName ? errors.othersName.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                NRIC Number
              </Typography>
              <TextInput
                type="text"
                {...register("othersNRIC", {
                  required: false,
                })}
                onErrorCheck={errors.othersNRIC ? errors.othersNRIC.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Date of Birth
              </Typography>
              <BasicDatePicker
                {...register("othersDOB", {
                  required: false,
                })}
                onErrorCheck={errors.othersDOB ? errors.othersDOB.message : ""}
                control={control}
                name="othersDOB"
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Office Tel. No.
              </Typography>

              <LandLinePhoneFormatter name="othersOfficeTelNo" onErrorCheck={errors.othersOfficeTelNo ? errors.othersOfficeTelNo.message : ""} control={control} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                H/phone No.
              </Typography>
              <Controller
                name="othersHPNo"
                control={control}
                rules={{ required: false }}
                render={({ field }) => (
                  <MuiTelInput
                    {...field}
                    value={field.value}
                    onChange={field.onChange}
                    defaultCountry="MY"
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        fontSize: "16px",
                        borderRadius: "25px",
                        color: "black",
                        backgroundColor: "white",
                        "& fieldset": {
                          borderColor: "#ccc",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                        // "&.Mui-focused fieldset": {
                        //   borderColor: "transparent",
                        //   outline: "none",
                        // },
                      },
                    }}
                    error={Boolean(errors.othersHPNo)}
                    helperText={errors.othersHPNo ? errors.othersHPNo.message : ""}
                  />
                )}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Email
              </Typography>
              <TextInput
                type="text"
                {...register("othersEmail", {
                  required: false,
                })}
                onErrorCheck={errors.othersEmail ? errors.othersEmail.message : ""}
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>
              <TextInput
                type="text"
                {...register("othersDesignation", {
                  required: false,
                })}
                onErrorCheck={errors.othersDesignation ? errors.othersDesignation.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Nature of Work
              </Typography>
              <TextInput
                type="text"
                {...register("othersNatureOfWork", {
                  required: false,
                })}
                onErrorCheck={errors.othersNatureOfWork ? errors.othersNatureOfWork.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Number of Years With Company
              </Typography>
              <TextInput
                type="number"
                {...register("othersNoOfYearsWithCompany", {
                  required: false,
                })}
                onErrorCheck={errors.othersNoOfYearsWithCompany ? errors.othersNoOfYearsWithCompany.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Academic Qualification
              </Typography>
              <SelectInput
                type="select"
                {...register("othersAcademicQualification", {
                  required: false,
                })}
                onErrorCheck={errors.othersAcademicQualification ? errors.othersAcademicQualification.message : ""}
                control={control}
              />
            </Grid>
          </Grid>

          <Box sx={{ marginTop: 5, display: 'flex', justifyContent: 'center' }}>
            {/* <HCaptcha
              sitekey="268ee364-a8e6-44aa-a1b2-e906701ec176"
              onVerify={(token,ekey) => {SetHCaptchaToken(token);}}
            /> */}
            <ICaptcha captchaVerification={captchaVerification} SetCaptchaVerification={SetCaptchaVerification} codeLength={4} />
          </Box>

          <Box sx={{ marginTop: 5 }}>
            <Button
              sx={{
                bottom: "16px", // Distance from the bottom of the screen
                left: "0", // Position from the left edge of the screen
                right: "0", // Position from the right edge to keep it full width
                zIndex: 1000, // Ensure it's above other content
                borderRadius: "20px",
                mt: 4,
                mb: 4,
                width: "100%", // Set initial width as a percentage
                // maxWidth: "1150px", // Set a maximum width to avoid the button getting too large
                minWidth: "200px", // Set a minimum width to avoid the button getting too small
                height: "48px",
                backgroundColor: "#d33333",
                margin: "0 auto", // Center the button horizontally
              }}
              variant="contained"
              type="submit"
              disabled={!captchaVerification}
            >
              <Typography variant="h6">Save</Typography>
            </Button>
          </Box>
        </Box>
      </form>

      {popupMessage.length > 0 ? RenderPopupMessageBox() : null}
    </>
  );
};

export default Register;
